import React, {  useRef } from 'react';

import 'react-alice-carousel/lib/alice-carousel.css';
import FileService from '../service/FileService';

const CustomArtLabel = (props) => {

    const ref = useRef(null);
    return (
            <div style={{
                flexDirection: 'row',
                display: 'flex',

            }}
            >
                <div style={{
                    ...props.style,
                    flexDirection: 'row',
                    display: 'flex',
                    background: props.background ? props.background : 'rgba(255,255, 255, 0.65)',
                    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                    borderRadius: 20,
                    backdropFilter: 'blur(10px)',
                    padding: 5,
                    alignItems: 'center',
                    

                }}>
                    <img style={{ width: 25, height: 25, borderRadius: 30 }} src={FileService.inquireFilePath(props.image?props.image:"/assets/layout/images/profile-image.png")} />
                    <div style={{ paddingLeft: 10,paddingRight: 10, color:  props.textColor ? props.textColor :'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>  {props.label}</div>
                </div>

            </div>
    );
};

export default CustomArtLabel;
